import React from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

interface DevopsRecordShellProps {
  title: string;
  backPath: string;
  backLabel?: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

const DevopsRecordShell: React.FC<DevopsRecordShellProps> = ({
  title,
  backPath,
  backLabel = "Back to list",
  actions,
  children,
}) => {
  const navigate = useNavigate();
  return (
    <Box>
      <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate(backPath)}
        sx={{ mb: 1 }}
      >
        {backLabel}
      </Button>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ sm: "center" }}
        spacing={1}
        sx={{ mb: 2 }}
      >
        <Typography variant="h5" fontWeight={600}>
          {title}
        </Typography>
        {actions ? <Stack direction="row" spacing={1}>{actions}</Stack> : null}
      </Stack>
      <Stack spacing={2}>{children}</Stack>
    </Box>
  );
};

export default DevopsRecordShell;
